module.exports = __webpack_public_path__ + "media/images/lp/1/support-ashinaga3-sp-140756129040b5bf1c756441003abdb2.png";